import React, { useState } from "react";
import { connect } from "react-redux";
import { Swipeable } from "react-swipeable";
import styled from "styled-components";

import Slider from "../../components/Slider";
import Graph from "../../components/graphs/ZoomedGraph";
import GraphOptions from "./GraphOptions";
import PublicGraph from "../../components/graphs/PublicServicesGraph";
import MainGraph from "../../components/graphs/MainServicesGraph";
import CircleGraph from "../../components/graphs/CircleFillGraph";
import Map from "../../components/Map";
import {
  Main,
  ZoomedSliderContainer as SliderContainer,
  PageDetail,
  CountData,
  CircleGraphsTitle,
  CirclesGraphContainer,
  LocationDetail,
  TopHandle,
  RightArrowIconSt,
  LeftArrowIconSt,
  ZoomedMainArea as MainArea,
  ZoomedGraphContainer as GraphContainer,
  LocationCircleGraphsTitle,
  SingleCircle,
  SingleCircleDetail,
  CircleAndDetail
} from "../../components/StyledComponents";

import {
  handleLocationClick,
  handleLocationSwipe,
  closeZoom,
  changeMapView
} from "./data/actions";

import { filterService } from "../Services/data/actions";
import { getDevice, devices } from "../../services/getDevice";

const LocationDetailContainer = styled.div`
  position: absolute;
  left: ${props => -54 * props.cardNo - 27}vw;
  transition: left ease 1s, bottom ease 1s;
  z-index: 1;
  bottom: ${props => (props.isSwipedUp ? 0 : "-25%")};
  min-width: 100%;
  display: flex;
  justify-content: center;
  @media (max-width: 575px) {
    left: ${props => -90 * props.cardNo - 85}vw;
  }
`;

const GraphDetailContainer = styled.div`
  margin-left: ${props => (props.isMap ? 0 : "23.5%")};
  margin-right: 5%;
  display: flex;
  @media (min-width: 1800px) {
    margin-left: ${props => (props.isMap ? 0 : "22.7%")};
  }
  @media (max-width: 575px) {
    width: 100%;
    margin-right: 0;
    margin-left: 0;
  }
`;

const EntityZoomed = props => {
  const [chosenMenu, setChosenMenu] = useState(1);
  const [chosenGraph, setChosenGraph] = useState("public");
  const [channelsDropdownOpen, setchannelsDropdownOpen] = useState(false);

  const {
    cardNo,
    zoomed,
    handleLocationClick,
    serviceCenterLocations,
    handleLocationSwipe,
    activeLocation,
    filterService,
    serviceData,
    filteredData,
    isFiltered,
    isSwipedUp,
    theme,
    data,
    view,
    changeMapView,
    closeZoom,
    verticalGraphData,
    counts,
    totalCount
  } = props;

  const serviceKPIsData = isFiltered ? filteredData : serviceData;

  return (
    <>
      <GraphOptions
        chosen={chosenMenu}
        setChosen={setChosenMenu}
        chosenGraph={chosenGraph}
        setChosenGraph={setChosenGraph}
        channelsDropdownOpen={channelsDropdownOpen}
        setchannelsDropdownOpen={setchannelsDropdownOpen}
        mapOption={view}
        setMapOption={changeMapView}
        verticalGraphData={verticalGraphData}
      />
      {getDevice() !== devices.mobile && (
        <Main>
          <GraphDetailContainer isMap={chosenMenu === 3}>
            <MainArea isOverlay={chosenMenu === 3}>
              {chosenMenu === 1 && (
                <>
                  <GraphContainer>
                    <LeftArrowIconSt />
                    <Graph
                      data={data}
                      color="#6678D1"
                      gradient={["#041A2F", "#6678D1"]}
                    />
                    <RightArrowIconSt />
                  </GraphContainer>
                  <SliderContainer>
                    <Slider theme={theme} />
                  </SliderContainer>
                </>
              )}
              {chosenMenu === 2 && (
                <>
                  <PageDetail>مجموع عدد الخدمات</PageDetail>
                  {chosenGraph === "public" ? (
                    <>
                      <CountData>400 خدمة حكومية</CountData>

                      <PageDetail>
                        المؤشر المئوي لمجموع الخدمات للجهة الحكومية
                      </PageDetail>
                      <PublicGraph onServiceFilter={filterService} />
                    </>
                  ) : (
                      <>
                        <CountData>8 خدمات رئيسية</CountData>

                        <PageDetail>
                          المؤشر المئوي لمجموع الخدمات لجمارك دبي
                      </PageDetail>
                        <MainGraph onServiceFilter={filterService} />
                      </>
                    )}

                  <CircleGraphsTitle>
                    متوسط أداء مؤشرات الخدمات{" "}
                  </CircleGraphsTitle>
                  <CirclesGraphContainer>
                    {serviceKPIsData.map((item, i) => (
                      <CircleAndDetail key={`service-circle-${i}`}>
                        <SingleCircle>
                          <CircleGraph
                            key={i}
                            value={item.value}
                            title={item.name}
                          />
                        </SingleCircle>
                        <SingleCircleDetail>
                          {item.name}
                          <br />
                          {item.detail}
                        </SingleCircleDetail>
                      </CircleAndDetail>
                    ))}
                  </CirclesGraphContainer>
                </>
              )}

              {chosenMenu === 3 && (
                <>
                  <Map
                    view={view}
                    dragPan={!(view === "VIZ" || zoomed)}
                    onMapClick={place => handleLocationClick(place.datum)}
                    markLocations={serviceCenterLocations}
                    activeLocation={activeLocation}
                    onZoomClose={closeZoom}
                    zoomed={zoomed}
                    changeMapView={changeMapView}
                    counts={counts}
                    totalCount={totalCount}
                  />
                  {zoomed && view === "MAP" && (
                    <Swipeable
                      onSwipedUp={() => handleLocationSwipe("Up")}
                      onSwipedDown={() => handleLocationSwipe("Down")}
                      trackMouse
                      onSwipedLeft={() => handleLocationSwipe("Left")}
                      onSwipedRight={() => handleLocationSwipe("Right")}
                    >
                      <LocationDetailContainer
                        cardNo={cardNo}
                        isSwipedUp={isSwipedUp}
                      >
                        {[...Array(serviceCenterLocations.length)].map(
                          (_, i) => (
                            <LocationDetail key={i} isSwipedUp={isSwipedUp}>
                              <TopHandle />
                              {getDevice() !== devices.mobile && (
                                <>
                                  <PageDetail>
                                    المؤشر المئوي لمجموع الخدمات للجهة الحكومية
                                  </PageDetail>
                                  <PublicGraph
                                    onServiceFilter={filterService}
                                    id="public-graph-1"
                                  />
                                </>
                              )}
                              <LocationCircleGraphsTitle>
                                متوسط أداء مؤشرات الخدمات
                              </LocationCircleGraphsTitle>
                              <CirclesGraphContainer>
                                {serviceKPIsData.map((item, i) => (
                                  <CircleAndDetail key={`service-circle-${i}`}>
                                    <SingleCircle>
                                      <CircleGraph
                                        key={i}
                                        value={item.value}
                                        title={item.name}
                                      />
                                    </SingleCircle>
                                    <SingleCircleDetail>
                                      {item.name}
                                      <br />
                                      {item.detail}
                                    </SingleCircleDetail>
                                  </CircleAndDetail>
                                ))}
                              </CirclesGraphContainer>
                            </LocationDetail>
                          )
                        )}
                      </LocationDetailContainer>
                    </Swipeable>
                  )}
                </>
              )}
            </MainArea>
          </GraphDetailContainer>
        </Main>
      )}
    </>
  );
};

const mapStateToProps = state => ({
  theme: state.themes.theme,

  zoomed: state.entityZoomed.isZoomed,
  serviceCenterLocations: state.entityZoomed.serviceCenterLocations,
  cardNo: state.entityZoomed.cardNo,
  activeLocation: state.entityZoomed.activeLocation,
  isSwipedUp: state.entityZoomed.isSwipedUp,
  data: state.entityZoomed.data,
  view: state.entityZoomed.view,
  verticalGraphData: state.entityZoomed.verticalGraphData,
  counts: state.entityZoomed.counts,
  totalCount: state.entityZoomed.totalCount,

  serviceData: state.services.data,
  filteredData: state.services.filteredData,
  isFiltered: state.services.isFiltered
});

const mapDispatchToProps = {
  handleLocationClick,
  handleLocationSwipe,
  filterService,
  changeMapView,
  closeZoom
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EntityZoomed);